import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icons';
import LuxReveal from './LuxReveal';

const steps = [
  {
    num: '01',
    icon: 'cpu',
    title: 'Hands-On Lab',
    desc: 'Work on real PLC panels, SCADA screens, and industrial hardware from day one — not just theory.',
  },
  {
    num: '02',
    icon: 'layers',
    title: 'Live Projects',
    desc: 'Industry-oriented assignments and panel wiring exercises that mirror factory workflows.',
  },
  {
    num: '03',
    icon: 'briefcase',
    title: 'Placement Track',
    desc: 'Resume building, mock interviews, and recruiter introductions until you are job-ready.',
  },
];

const highlights = [
  { label: 'Batch Size', value: 'Limited seats', sub: 'Personal mentor attention' },
  { label: 'Location', value: 'Sector-3 Noida', sub: 'Near Sector-16 Metro' },
  { label: 'Mode', value: 'Regular & Weekend', sub: 'Flexible schedules' },
  { label: 'Support', value: '100% Placement', sub: 'Dedicated career team' },
];

export default function TrainingJourney() {
  return (
    <section className="lux-journey">
      <div className="lux-journey__grid container-wide">
        <LuxReveal className="lux-journey__visual">
          <div className="lux-journey__img-main">
            <img src="/pl2.jpeg" alt="Students at PLC lab" loading="lazy" />
          </div>
          <div className="lux-journey__img-accent">
            <img src="/pl7.jpg" alt="Industrial training workshop" loading="lazy" />
          </div>
        </LuxReveal>

        <div className="lux-journey__content">
          <LuxReveal>
            <p className="lux-statement__eyebrow">How we train</p>
            <h2 className="video-gallery__title">
              Your path from<br />
              <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>learner to professional</em>
            </h2>
            <p style={{ color: 'var(--text-secondary)', marginTop: 20, lineHeight: 1.8, maxWidth: 480 }}>
              Bharat Training is built for students who want factory-ready skills — PLC, SCADA, automation, SAP and IT programs under one roof in Noida.
            </p>
          </LuxReveal>

          <div className="lux-journey__steps">
            {steps.map((s, i) => (
              <LuxReveal key={s.num} delay={i * 0.08} y={24}>
                <div className="lux-journey__step">
                  <span className="lux-journey__num">{s.num}</span>
                  <div className="icon-wrap" style={{ width: 40, height: 40 }}>
                    <Icon name={s.icon} size={18} />
                  </div>
                  <div>
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                  </div>
                </div>
              </LuxReveal>
            ))}
          </div>

          <LuxReveal delay={0.2}>
            <Link to="/about" className="btn-lux btn-lux--line" style={{ marginTop: 28, display: 'inline-flex', color: 'var(--text)' }}>
              About our institute
            </Link>
          </LuxReveal>
        </div>
      </div>

      <div className="lux-journey__highlights">
        {highlights.map((h, i) => (
          <LuxReveal key={h.label} delay={i * 0.06} y={20}>
            <div className="lux-journey__highlight-cell">
              <span className="lux-journey__highlight-label">{h.label}</span>
              <strong>{h.value}</strong>
              <span>{h.sub}</span>
            </div>
          </LuxReveal>
        ))}
      </div>
    </section>
  );
}
